<template>
  <div class="">
    <page-cards :pages="pageObjects" :columns="columns"/>
  </div>
</template>

<script>
  import http from '@/http'
  import PageCards from '@/components/PageCards.vue';

  export default {
    components: {
      PageCards
    },
    data() {
      return {
        pageObjects: []
      }
    },
    props: {
      pages: Array,
      columns: String
    },
    mounted() {
      this.fetchPages();
    },
    methods: {
      fetchPages() {
        return http.authGet(`pages?pages=${this.pages}`)
          .then((pages) => {
            this.pageObjects = pages;
          });
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>
